import React from "react";
import "./_EmailSentModal.scss";
import { ButtonRounded, Header } from "..";

export const EmailSentModal = ({
  titleText,
  text,
  buttonText,
  onClick,
  open = false,
}) => {
  return (
    <div className={`email-sent-modal ${open ? "open" : null}`}>
      <div className="email-sent-modal-container">
        <Header titleText={titleText} />
        <span className="email-sent-modal-text">{text}</span>
        <ButtonRounded
          onClick={onClick}
          buttonText={buttonText}
          color="copper"
        />
      </div>
    </div>
  );
};
